import {FormProvider, useForm} from 'react-hook-form';
import {Input} from "../components/layout";
import React from "react";

export const Prueba = (props) => {
  const methods = useForm({
    defaultValues: {
      hosts: [
      ]
    }
  });
  const {handleSubmit, control} = methods;
  const prepareData = (data) => {
  }

  const inputs = {
    id: 'hosts',
    name: 'hosts',
    input: 'selectChip',
    label: 'inventoryList.form.name.label',
    placeholder: 'inventoryList.form.name.placeholder',
    rules: {
      required: {value: true},
    },
  }

  const options = [
    {value: '123.123.123.123', label: 'Prueba'},
    {value: '123.123.123.124', label: 'Prueba3'},
    {value: '123.123.123.124', label: 'Prueba3'},
  ]

  return (
    <FormProvider{...methods} >

      <form onSubmit={handleSubmit(prepareData)}>
        <Input
          {...inputs}
          control={control}
          options={options}
          sx={{width: '100%'}}
        />
      </form>

    </FormProvider>
  )
}
